<template>
  <div class="p-grid">
    <div class="p-col-12">
      <br />
      

      <h4>List of Quotation Versions</h4>

      <Toolbar class="p-mb-4">
        <template slot="left">
          <!-- <Button
            label="New Attachment"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            @click="openNew"
          /> -->
        </template>

        <template slot="right">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global']"
              placeholder="Global Search"
              style="margin-right: 0.5em"
              @input="updateSearch"
            />
          </span>
        </template>
      </Toolbar>

      <VersionTable
        v-if="Array.isArray(versions)"
        :key="versionsKey"
        :versions="versions"
        :filters="filters"
        :loading="loading"
        @reload="reload"
        @editQuote="editQuote"
      />

    </div>

    <QuotationForm
      :quotationDialog="quotationDialog"
      :active="false"
      :quoteToEdit="quotationVersion"
      :disabledArr="[]"
      @close="quotationDialog = false"
      @saved="saved"
    />

  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";

import VersionTable from './versionsTable'
import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";

export default {
  components: {
    VersionTable,
    QuotationForm
  },
  data: () => ({
    quotationService: new QuotationService(),
    filters: {},
    versionsKey: 0,
    quotationDialog: false,
    quotationVersion: {},
    selectedCustomer: {},
    requesting: false
  }),
  computed: {
    quotation() {
      return this.$store.getters['quotations/getQuoteForTabs']
    },
    loading() {
      if (this.versions && this.versions[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    },
    versions() {
      return this.$store.getters['quotations/getQuoteVersionsForTab']
    }
  },
  watch: {
    versions(val) {
      if (val) {
        this.versionsKey++
      }
    }
  },
  methods: {
    editQuote(quotation) {
      this.quotationVersion = quotation
      this.selectedCustomer = quotation.customer
      this.quotationDialog = true
    },
    saved({ quote, file, params, active }) {
      
      this.quotationDialog = false
      this.quotationVersion = {};
      this.reload()
    },
    reload() {
      this.requesting = true
      this.quotationService
        .getQuotationVersions(
          this.quotation.sQuoteNo,
          this.quotation.opportunity && this.quotation.opportunity.oppId
        )
        .then(data => {
          this.requesting = false
          this.$store.dispatch('quotations/setQuoteVersionsForTab', data)
        })
        .catch(err => {
          this.requesting = false
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotation versions",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "quotationversions/{sQuoteNo}"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>